function formatCPF(cpf) {
  // Remove qualquer caractere que não seja número
  cpf = cpf.replace(/\D/g, '')

  // Verifica se o CPF tem 11 dígitos
  if (cpf.length !== 11) {
    return 'CPF inválido'
  }

  // Formata o CPF com pontos e traço
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

export { formatCPF }
